module.exports = __webpack_public_path__ + "img/6.1c0b9771.jpg";